export default __webpack_public_path__ + "static/media/IPO-TSLA-vh.20ed97c6.png";